import React from "react";
import SidebarContent from "./../layout/SidebarContent";

type Props = {
  onToggle: () => void;
};

const SidebarExpanded: React.FC<Props> = ({ onToggle }) => {
  return (
    <aside className="fixed top-0 left-0 h-full w-60 bg-white shadow-md z-50 border-r">
      <SidebarContent variant="expanded" onToggle={onToggle} />
    </aside>
  );
};

export default SidebarExpanded;